import {useLanguage} from "../../../LanguageContext";
import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import {priceText, subTitle, textStyle, title} from "../../styles/TabStyles";
import FullScreenTab from "./FullScreenTab";

const PriceTab = ({content}) => {
    const {t} = useLanguage();

    return (
        <FullScreenTab>
            {/*// grid*/}
            <Grid container justifyContent="center"
                  sx={{p: 5}}
            >
                {/* First Item */}
                <Grid item xs={12} lg={4}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: 'center'
                        }}
                    >
                        <Box>
                            <Typography sx={title}>
                                {t('label_price_include')}
                            </Typography>
                            <Box
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {t(content.includes).map((sentences, index) => (
                                    <Typography
                                        key={index}
                                        sx={textStyle}>
                                        {sentences}
                                    </Typography>
                                ))}
                            </Box>

                        </Box>
                    </Box>
                </Grid>

                {/* Second Item */}
                <Grid item xs={12} lg={4}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: 'center',
                            pt: {
                                xs: '40px',
                                md: '0px',
                            }
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: '600px'
                            }}>
                            <Typography sx={title}>
                                {t('label_price_extras')}
                            </Typography>
                            <Box
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {t(content.notIncludes).map((sentences, index) => (
                                    <Typography
                                        key={index}
                                        sx={textStyle}>
                                        {sentences}
                                    </Typography>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>


            <Box
                sx={{
                    pt: '40px',
                    textAlign: 'center'
                }}
            >

                <Typography sx={priceText}>
                    {t('label_adv_cost')} {t(content.price)}
                </Typography>
                <Typography sx={subTitle}>
                    {t('label_price_activities')}
                </Typography>

            </Box>


        </FullScreenTab>
    );
}


export default PriceTab;
